export const ReplaceMeSelectionType = Object.freeze({
  /**
   * Today - Today button selected
   */
  TODAY: 'Today',
  /**
   * Tomorrow - Tomorrow or Next Monday button selected
   */
  TOMORROW: 'Tomorrow',
})
